import { useEffect, type EffectCallback } from 'react';

/**
 * Run an effect exactly once on mount (and its cleanup on unmount).
 *
 * This is the **only** sanctioned wrapper around `useEffect` in PSP. Use it for
 * genuine mount-only external synchronization — registering with a non-React
 * store, wiring a third-party widget, one-time analytics — where there is no
 * reactive dependency to track. Prefer derived state, event handlers, data
 * libraries, or `key`-based remounts for everything else.
 */
export function useMountEffect(effect: EffectCallback): void {
  // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only by design
  useEffect(effect, []);
}
